import React, { useState } from 'react';
import {
  Popover,
  PopoverProvider,
  PopoverTrigger,
  ToolkitFeatureFlag,
  Tooltip,
} from '@cko/primitives';
import { trackEvent } from '@cko/dashboard-shared';

import { Bell } from '../../../utils/MenuIcons/Bell';
import { NotificationsList } from './components/NotificationsList';

import { useNotifications } from './contexts/NotificationsProvider';
import { InnerDot, ListButton, OuterDot } from './Notifications.styles';

export const DOT_TEST_ID = 'notifications-in-navigation-list-button-dot';

export const Notifications = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    hasErrorLoadingList,
    hasUnseenNotifications,
    isLoadingList,
    notifications,
    updateLastSeenTimestamp,
  } = useNotifications();

  const closeList = () => {
    setIsOpen(false);
  };

  const handleListButtonClick = () => {
    setIsOpen((previousIsOpen) => !previousIsOpen);
    trackEvent('Click - in-dashboard notifications - notification icon button', {});
    updateLastSeenTimestamp();
  };

  return (
    <PopoverProvider open={isOpen} onOpenChange={() => setIsOpen(!isOpen)}>
      <ToolkitFeatureFlag flag="v10">
        <Tooltip text="Notifications">
          <PopoverTrigger>
            <ListButton onClick={handleListButtonClick} aria-label="notifications">
              {hasUnseenNotifications && (
                <OuterDot data-testid={DOT_TEST_ID}>
                  <InnerDot />
                </OuterDot>
              )}
              <Bell />
            </ListButton>
          </PopoverTrigger>
        </Tooltip>
      </ToolkitFeatureFlag>
      <Popover defaultDirection="bottom-end">
        <NotificationsList
          closeList={closeList}
          isError={hasErrorLoadingList}
          isLoading={isLoadingList}
          notifications={notifications}
        />
      </Popover>
    </PopoverProvider>
  );
};
